import {Strings} from '@zvne/fe-framework/dist/presentation/language/strings';

const en = {
    startTimestamp: 'Start time',
    durationMinutes: 'Duration [min]',
    submit: 'Submit',
    clusterHistory: 'Cluster history',
    prediction: (step: number) => step === 0 ? 'Reality' : `Prediction step ${step}`,
    layers: 'Layers',
    strokes: 'stroke(s)'
};

const hr = {
    startTimestamp: 'Vrijeme od',
    durationMinutes: 'Trajanje [min]',
    submit: 'Prikaži',
    clusterHistory: 'Povijest klastera',
    prediction: (step: number) => step === 0 ? 'Stvarnost' : `Korak ${step} predviđanja`,
    layers: 'Slojevi',
    strokes: 'udar(a)'
};

export const strings: Strings<typeof en> = {en, hr};

